import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const MeetingConcatenationSchema = z.object({
    entityId: CornSchema,
    chimeMeetingId: z.string(),
    meetingId: z.string(),
    meetingStartTime: z.string(),
    meetingEndTime: z.string().optional(),
    mediaConcatenationPipeline: z.record(z.string(), z.unknown()),
});
